
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Berättelse',
	'noDashboardFound': 'Det går inte att hämta berättelsen. Den kanske inte finns längre eller så saknar du behörighet att se den.',
	'noDashboardCapability': 'Du har inte behörighet att använda berättelser',
	'noDashboardPermision': 'Du har inte behörighet att visa berättelsen',
	'defaultName': 'Ny berättelse',
	'storyProperties': 'Berättelseegenskaper',
	'createAvDataStoryLabel': 'Berättelse',
	'createAvSlideShowLabel': 'Bildspel',
	'createAvPanAndZoomLabel': 'Vägledd tidslinje',
	'dashboard_save_success': 'Berättelsen har sparats.',
	'cmEmptySelection': 'Berättelsen har tagits bort. Försök spara som en ny berättelse.',
	'createStoryTitle': 'Skapa en berättelse',
	'transitionStyleTitle': 'Övergångsformat',
	'createButton': 'Skapa',
	'cancelButton': 'Avbryt',
	'dashboardResetTitle': 'Återställ berättelse',
	'dashboardResetMessage': 'Vill du återställa alla ändringar som tillämpats på berättelsen?',
	'dashboardResetToast': 'Berättelsen har återställts.',
	'filter_drag_and_drop_all_tabs': 'Dra data hit för att filtrera alla scener.',
	'filter_drag_and_drop_current_tab': 'Dra data hit för att filtrera den här scenen.',
	'filterIconLabel_Global': 'Alla scener',
	'filterIconLabel_Tab': 'Den här scenen',
	'filterIconTooltip_Global': 'Alla scener',
	'filterIconTooltip_Tab': 'Den här scenen',
	'filterOverflowMenu_Global': 'Alla sceners spillmeny',
	'filterOverflowMenu_Tab': 'Den här scenens spillmeny',
	'renameScene': 'Byt namn på scen',
	'duplicateScene': 'Duplicera scen',
	'deleteScene': 'Ta bort scen',
	'editTimelineHighlight': 'Ändra markering',
	'deleteTimelineHighlight': 'Ta bort markering',
	'filter_includesAll': 'Inkluderar alla',
	'timeline_highlight_moved_to': 'Tidslinjemarkering %{id} flyttad till %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Välj',
	'newDefaultStoryName': 'Berättelse: %{modelName}',
	'exportLabel': 'Spara',
	'exportAsLabel': 'Spara som:',
	'exportDialogTitle': 'Spara som berättelse',
	'exportDialogFooter': 'Spara och avbryt',
	'loadAfterExportLabel': 'Öppna berättelse efter att ha sparat',
	'selectTemplateLabel': 'Välj en mall',
	'outOfBoundsWarningMessage': 'Vissa kontrollpanelswidgetar ligger utanför rutnätet och kanske inte visas på rätt sätt efter exporten.',
	'emptyExploreCardsWarningMessage': 'Tomma kort togs bort när berättelsen sparades.',
	'dashboard_export_success': 'Kontrollpanelen sparades som en berättelse.',
	'explore_export_success': 'Utforskningen sparades som en berättelse.',
	'toastUpgradeDone': 'Berättelsen har uppgraderats. Spara nu för optimala prestanda.',
	'navigationMarker': 'Navigeringsmarkör',
	'navigateMarkers': 'Navigeringsmarkörer',
	'navNextMarker': 'Nästa markör',
	'navPrevMarker': 'Föregående markör',
	'navPrevMarkerAbbreviated': 'Förra',
	'timelineSettingsButton': 'Uppspelningsalternativ',
	'autoPlay': 'Spela alla scener',
	'loop': 'Slinga',
	'refreshData': 'Uppdatera vid start',
	'slideshowLabel': 'Bildspel',
	'panAndZoomLabel': 'Vägledd tidslinje',
	'slideShowLayoutLabel': 'Bildspelslayout',
	'panAndZoomLayoutLabel': 'Vägledd tidslinjelayout',
	'panAndZoomLayoutFooter': 'En vägledd tidslinjelayout är en samling scener på en enskild arbetsyta. När du kör den här typen av berättelse zoomar och panorerar presentationen på varje enskild scen i sekvensordning. Det skiljer sig från ett bildspel där varje scen presenteras på en ny arbetsyta. Den vägledda tidslinjelayouten med tre scener kopplade via linjer gör att du kan skapa en horisontell sekvens av scener. Det är användbart för visning av tidslinjer.',
	'PanAndZoomLayout1': '5 scener arrangerade i rektangulär form',
	'PanAndZoomLayout2': '4 scener arrangerade i en uppåtgående trappa från vänster till höger',
	'PanAndZoomLayout3': '6 scener arrangerade i rektangulär form',
	'PanAndZoomLayout4': '7 scener arrangerade i rektangulär form, med 6 små scener överst och 1 stor scen nederst.',
	'PanAndZoomLayout5': '3 scener arrangerade med 2 små scener överst och 1 stor scen nederst.',
	'PanAndZoomLayout6': 'En sekvens av 4 scener arrangerade horisontellt',
	'pageSelectWarning': 'Välj en scen.',
	'noSceneTransitionLabel': 'Inget',
	'sceneTransitionPropertyLabel': 'Scenöverföring',
	'animatedPathSceneTransitionLabel': 'Animeringsväg',
	'sweepSceneTransitionLabel': 'Svep',
	'storyTypeLabel': 'Berättelsetyp',
	'layoutLabel': 'Layout',
	'tabName_animation': 'Animering',
	'propAniAnimation': 'Animering',
	'propAniTypeEntrance': 'Ingångsanimering',
	'propAniDirectionIn': 'Ingångsriktning',
	'propAniTypeExit': 'Utgångsanimering',
	'propAniDirectionOut': 'Utgångsriktning',
	'propAniDirection': 'Riktning',
	'propAniEntrance': 'Ingång',
	'propAniTypeEntranceSlideIn': 'Glid in',
	'propAniTypeEntranceFadeIn': 'Tona in',
	'propAniTypeEntrancePivotIn': 'Pivotera in',
	'propAniTypeEntranceScaleIn': 'Skala in',
	'propAniTypeEntranceShrinkIn': 'Krymp in',
	'propAniDirectionInLeft': 'Från vänster',
	'propAniDirectionInRight': 'Från höger',
	'propAniDirectionInTop': 'Uppifrån',
	'propAniDirectionInBottom': 'Nedifrån',
	'propAniExit': 'Avsluta',
	'propAniTypeExitSlideIn': 'Glid ut',
	'propAniTypeExitFadeIn': 'Tona ut',
	'propAniTypeExitPivotOut': 'Pivotera ut',
	'propAniTypeExitScaleIn': 'Skala ut',
	'propAniTypeExitExpandOut': 'Expandera ut',
	'propAniDirectionOutLeft': 'Åt vänster',
	'propAniDirectionOutRight': 'Åt höger',
	'propAniDirectionOutTop': 'Till början',
	'propAniDirectionOutBottom': 'Till slutet',
	'propAniEntranceTime': 'Starta om (sekunder):',
	'propAniExitTime': 'Sluta om (sekunder):',
	'animationNoEntranceText': 'Ingångsanimering förekommer inte om widgeten finns i början av scenen.',
	'animationNoExitText': 'Utgångsanimering förekommer inte om widgeten finns i slutet av scenen.',
	'propAniTypeDataEntrance': 'Dataingång',
	'propAniRevealDuration': 'Längd på ingångsanimering',
	'timelineAnimationProperties': 'Öppna animeringsegenskaper',
	'scenesPropertiesSection': 'Scener',
	'editStoryCoachMarkTitle': 'Ändra berättelse',
	'editStoryCoachMarkContents': 'Klicka på penseln om du vill ändra berättelsen.',
	'addDataStoryCoachMarkContents': 'Dra data från datapanelen till berättelsen.',
	'expandSceneCoachmarkTitle': 'Öppna tidslinje',
	'expandSceneCoachmarkContents': 'Animera en scen genom att justera objektvisibiliteten baserat på tid och längd.',
	'overviewCoachmarkTitle': 'Översiktsscener',
	'overviewCoachmarkContents': 'Använd översiktsscenerna i början och slutet av berättelsen för att visa den stora bilden för alla scener. Klicka och dra en scen från en översiktsscen för att växla till en annan scen. Du kan visa eller dölja översiktsscener i egenskaperna.',
	'animatedPathCoachmarkTitle': 'Animeringsväg',
	'animatedPathCoachmarkContents': 'Animera ett objekt från en scen till en annan genom att kopiera en scen med ett objekt. Flytta, ändra storlek på eller rotera sedan det kopierade objektet på den nya scenen.',
	'propShowStoryOverviewFirstSlide': 'Visa alla scener i början',
	'propShowStoryOverviewLastSlide': 'Visa alla scener i slutet',
	'storySceneSingleCountLabel': '1 scen',
	'storySceneCountLabel': '%{count} scener',
	'storySceneRangeCountLabel': 'Scen %{index} av %{count}',
	'storySceneExpand': 'Öppna tidslinje',
	'storySceneActionMenu': 'Öppna scenalternativsmeny',
	'timelineRightContainerLabel': 'Knappkontrollgrupp för tidslinje',
	'timelineViewLabel': 'Tidslinje',
	'timelineZoomFit': 'Anpassa zoom',
	'timelineZoomIn': 'Zooma in',
	'timelineZoomOut': 'Zooma ut',
	'timelinePositionIndicator': 'tidslinjepositionsindikator på %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'tidslinjepositionsindikator - flytta åt vänster till %{position}',
	'timelinePositionIndicatorMoveRightTo': 'tidslinjepositionsindikator - flytta åt höger till %{position}',
	'sceneStart': 'Hoppa till början av scenen till %{position}',
	'sceneEnd': 'Hoppa till slutet av scenen till %{position}',
	'timelineHighlightTitle': 'Markera',
	'addTimelineHighlight': 'Lägg till markering',
	'addSceneBtnTitle': 'Lägg till en ny scen med standardmall',
	'addSceneChevronBtnTitle': 'Välj en scenmall',
	'timelinePlay': 'Kör',
	'timelinePause': 'Pausa',
	'sceneNavigation': 'Scennavigering',
	'navNextScene': 'Nästa scen',
	'navPrevScene': 'Föregående scen',
	'navPrevSceneAbbreviated': 'Förhandsgranska scen',
	'navExitFullScreen': 'Stäng helskärm',
	'navToggleOverview': 'Växla översikt',
	'rowNumber': 'Rad %{number}',
	'overviewBtnLabel': 'Översikt',
	'sceneListStart': 'Översiktsstart',
	'sceneListEnd': 'Översiktsslut',
	'timelineLeftHandle': 'vänster handtag för %{name}',
	'timelineRightHandle': 'höger handtag för %{name}',
	'timelineLeftHandleNoTitle': 'vänster handtag',
	'timelineRightHandleNoTitle': 'höger handtag',
	'timelineMoveLeft': 'Flytta %{object} åt vänster',
	'timelineMoveRight': 'Flytta %{object} åt höger',
	'timelineMoveWidget': 'tidslinjewidget flyttad till %{newStartTime} och %{newEndTime}',
	'timelineMoveWidgetStartTime': 'tidslinjewidgetens starttid ändrades till %{newStartTime}',
	'timelineMoveWidgetEndTime': 'tidslinjewidgetens sluttid ändrades till %{newEndTime}',
	'timelineMoveWidgetDown': 'tidslinjewidgeten flyttades ned',
	'timelineMoveWidgetUp': 'tidslinjewidgeten flyttades upp',
	'addSceneTitle': 'Lägg till en scen',
	'blankSceneLayout': 'Tom',
	'titleSceneLayout': 'Rubrik med underrubrik',
	'sceneLayout1': 'Rubrik med text bredvid en visualisering',
	'sceneLayout2': 'Rubrik med en visualisering',
	'sceneLayout3': 'Rurbik med två visualiseringar',
	'sceneLayout4': 'Flerfunktion',
	'sceneLayout5': 'Utan rubrik med text bredvid en visualisering',
	'sceneLayout6': 'Flerfunktion 2 gånger 2',
	'sceneLayout7': 'Flerfunktion 2 bredvid 1',
	'sceneLayout8': 'Flerfunktion 1 bredvid 2',
	'sceneLayout9': 'Flerfunktion 1 över 2',
	'sceneLayout10': 'Flerfunktion 2 över 1',
	'sceneLayout11': 'Flerfunktion 4 över 1',
	'sceneLayout12': 'Flerfunktion 1 över 1 bredvid 2 gånger 2 över 1',
	'titleWidgetPlaceholderText': 'Skriv rubriken här',
	'subtitleWidgetPlaceholderText': 'Skriv underrubriken här',
	'createStoryViewTitle': 'Skapa berättelse',
	'defaultStoryName': 'Ny berättelse',
	'screenshot_label': 'Berättelse %{title}',
	'screenshot_label_scene': 'Scen %{sceneTitle} i berättelse %{title}',
	'filmstripHandleOpenLabel': 'Öppna scenväljare',
	'filmstripHandleCloseLabel': 'Stäng scenväljare'
});
